import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
function getBreadcrumbsUtilityClass(slot) {
  return generateUtilityClass("MuiBreadcrumbs", slot);
}
const breadcrumbsClasses = generateUtilityClasses("MuiBreadcrumbs", ["root", "ol", "li", "separator"]);
const breadcrumbsClasses$1 = breadcrumbsClasses;
export {
  breadcrumbsClasses$1 as default,
  getBreadcrumbsUtilityClass
};
//# sourceMappingURL=breadcrumbsClasses.es.js.map
